module.exports = __webpack_public_path__ + "img/东莞市腾昌金属.f295516c.jpg";